// @flow
import type {
  IdealistDayEvent as ApiIdealistDayEvent,
  Creator as ApiCreator
} from 'api/groups';
import type { Action } from '../actions/idealistDayEvents';

export type IdealistDayEvent = {
  ...$Exact<ApiIdealistDayEvent>,
  isFetching: boolean
};

export type Creator = ApiCreator;

export type State = {
  byId: {
    [string]: {
      ...IdealistDayEvent,
      isFetching: boolean
    }
  }
};

export default function events(state: State = { byId: {} }, action: Action) {
  switch (action.type) {
    case 'FETCH_IDEALIST_DAY_EVENT_REQUEST':
      return {
        ...state,
        byId: {
          ...state.byId,
          [action.eventId]: {
            ...state.byId[action.eventId],
            id: action.eventId,
            isFetching: true
          }
        }
      };
    case 'FETCH_IDEALIST_DAY_EVENT_SUCCESS':
      return {
        ...state,
        byId: {
          ...state.byId,
          [action.event.id]: {
            ...action.event,
            isFetching: false
          }
        }
      };
    default:
      // this causes a flow error if there are any unhandled actions
      (action: empty); // eslint-disable-line no-unused-expressions
      return state;
  }
}
